/**
 * Zahlweise im Sheet „Zahlung erfassen" (`payment-create-method`, Spec 04b,
 * „Sheet Zahlung erfassen"). Optionen aus `GET /billing/payment-methods` —
 * der Client pflegt keine eigene Zuordnung von Werten auf deutsche
 * Bezeichnungen (`ARCHITECTURE.md` 6.6), dieselbe Begründung wie bei
 * `TermReasonField` (`features/contracts`).
 *
 * Vorgabe „Überweisung" (`transfer`) kommt aus dem Formularzustand des
 * Sheets, nicht von hier — dieses Feld zeigt nur, was zur Auswahl steht.
 *
 * Die Darstellung liegt in `components/EnumSelectField`; hier bleibt nur, was
 * fachlich ist: die Abfrage und die Beschriftung.
 */

import { usePaymentMethods } from '@/features/billing/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface PaymentMethodFieldProps {
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
}

export function PaymentMethodField({ value, onChange, error }: PaymentMethodFieldProps) {
  const methodsQuery = usePaymentMethods()

  return (
    <EnumSelectField
      label="Zahlweise"
      testId="payment-create-method"
      apiField="method"
      errorPrefix="payment-create"
      options={methodsQuery.data ?? []}
      isPending={methodsQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      required
    />
  )
}
